/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { signupStyle } from "./styles";
import { Input, Select } from "antd";
import { InputField } from "../../atoms/InputField";
import instructionsBckgnd from "../../assets/signup-instruction.png";
import instructionsBckgndMobile from "../../assets/signup-instruction-mobile.png";
import whatsappIcon from "../../assets/whatsapp-icon.svg";
import {
  joinUsNowText,
  login,
  countryCodes,
  getPageTitle,
  phoneNumberPrefixes,
  regexValidation,
  GAEvents,
} from "../../constants/commons";
import { RadioButtonSelect } from "../../atoms/RadioButtonSelect";
import {
  useDataFromServerToDropdwon,
  triggerUserLogin,
} from "../../utils/helpers";
import { responsiveStyles } from "../../commons/styles";
import { OTPInputField } from "../../atoms/OTPInputField";
import { useIsMobile, useIsTab } from "../../hooks/useIsMobile";
import useSTR from "react-str";
import { postData, getData } from "../../utils/fetchers";
import { URL } from "../../API/urlEndpoints";
import {
  SignInRequest,
  LeadType,
  SignUpRequest,
  Profession,
  ErrorObj,
} from "../../commons/interfaces";
import { useParams } from "react-router-dom";
import { SignUpError } from "../SignupError";
import { Spin } from "antd";
import ReCAPTCHA from "react-google-recaptcha";
import { DisplayInfo } from "../../atoms/DisplayInfo";
import { Status, WidgetType } from "../../atoms/DisplayInfo/interface";
import { GA_Event } from "../../utils/reactGA";
import { Checkbox } from "@curefit/pandora";

interface ISignUpProps {
  onLoginClick: () => void;
  onClose?: () => void;
}

export const SignUp: React.FC<ISignUpProps> = (props: ISignUpProps) => {
  const { partnerID } = useParams() as any;
  const recaptchaRef = React.createRef<any>();
  // [GET] API for fetching Professions List
  const [
    ,
    {
      result: onSuccessProfessionList,
      revalidator: refetchGetAPIforProfessions,
      loading: loadingSuccessProfessionListAPI,
      error: errorSuccessProfessionListAPI,
    },
  ] = useSTR(getData);
  // [GET] API for fetching ENABLED Professions List
  const [
    ,
    {
      result: onSuccessEnabledProfessionList,
      revalidator: refetchGetAPIforEnabledProfessions,
      loading: loadingSuccessEnabledProfessionListAPI,
      error: errorSuccessEnabledProfessionListAPI,
    },
  ] = useSTR(getData);
  // [POST] For Saving data on page.
  const [
    ,
    {
      result: onSuccessfulSignup,
      revalidator: refetchSignUpAPI,
      loading: loadingSignUpAPI,
      error: errorSignUpAPI,
    },
  ] = useSTR(postData);

  // [POST] API for the final ENdpoint post successfull OTP.
  const [
    ,
    {
      result: onSuccessfullOTPEntry,
      revalidator: refetchPostAPIAfterOTP,
      loading: loadingSuccessfullOTPEntryAPI,
      error: errorSuccessfullOTPEntryAPI,
    },
  ] = useSTR(postData);

  const isMobile = useIsMobile();
  const isTablet = useIsTab();
  const { onLoginClick } = props;

  // State which mainatins the tab click of User
  const [
    showSelectedProfession,
    setShowSelectedProfession,
  ] = React.useState<Profession>(getPageTitle(partnerID) as Profession);

  // State to maintain the user's First Full Name
  const [firstName, setFullName] = React.useState<string>();
  // State to maintain the Recaptcha
  const [reCaptchaVerififed, setReCaptchaVerififed] = React.useState<boolean>(
    false
  );
  // State to maintain the user's Second Full Name
  const [lastName, setLastName] = React.useState<string>();
  // State to maintain the user's Phone Number
  const [phoneNumber, setPhoneNumber] = React.useState<string>();
  // State which shows whether the OTP field should be shown or not
  const [showOTPfield, setShowOTPfield] = React.useState<boolean>(false);
  // State to maintain the email
  const [email, setEmail] = React.useState<string>();
  // State to maintain the whatsapp field
  const [extraCommunication, setExtraCommunication] = React.useState<boolean>(
    true
  );
  // State to show the Signup error component
  const [
    displayErrorComponent,
    setDisplayErrorComponent,
  ] = React.useState<boolean>(false);
  // State to show evaluate if user is verifed
  const [userVerified, setUserVerified] = React.useState<boolean>(false);
  // State to display the error message
  const [
    showRecievedErrorObjFromServer,
    setShowRecievedErrorObjFromServer,
  ] = React.useState<any>();

  const { Option } = Select;

  // On page load, showing the default professions
  React.useEffect(() => {
    refetchGetAPIforProfessions(`${URL.getProfessionsList}`);
    // Making sure that on PAGE-load, the OTPInputField component is hidden
    setShowOTPfield(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // On page load, showing the enabled professions
  React.useEffect(() => {
    refetchGetAPIforEnabledProfessions(`${URL.getEnabledProfessionsList}`);
    // Making sure that on PAGE-load, the OTPInputField component is hidden
    setShowOTPfield(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (!reCaptchaVerififed) {
      recaptchaRef?.current?.execute();
    }
    // eslint-disable-next-line
  }, [reCaptchaVerififed, recaptchaRef]);

  const reExecuteCaptchaVerification = () => {
    recaptchaRef?.current?.reset();
    recaptchaRef?.current?.execute();
  };

  // Stroring the value of the professionals that we got from API to a variable
  const professionsList = useDataFromServerToDropdwon(onSuccessProfessionList);

  const onFirstNameChange = (firstName: string) => {
    setFullName(firstName);
  };

  const onLastNameChange = (lastName: string) => {
    setLastName(lastName);
  };

  const onPhoneNumberChange = (phoneNumber: string) => {
    setPhoneNumber(phoneNumber);
  };

  const onEmailChange = (emailInput: string) => {
    setEmail(emailInput);
  };

  const onSelectedProfession = (event: any) => {
    setShowSelectedProfession(event.target.value);
  };

  const onJoinUsNowClick = () => {
    GA_Event(GAEvents.JOIN_US_NOW, "clicked", "from Signup Modal");
    let signUpObj: SignInRequest = {
      phone: {
        countryCode: countryCodes.INDIA,
        number: phoneNumber || "",
      },
    };
    refetchSignUpAPI(`${URL.postSignIn}`, signUpObj);
  };

  // Only on a successFull POST API call, allow him to go to the next screen
  React.useEffect(() => {
    if (onSuccessfulSignup && onSuccessfulSignup.success && !errorSignUpAPI) {
      setShowOTPfield(true);
    }
  }, [onSuccessfulSignup, errorSignUpAPI]);

  const onGoBackClick = () => {
    setShowOTPfield(false);
  };

  const onSuccessFullOTPEnter = (enteredOTP: string) => {
    let successFulPostAPIObj: SignUpRequest = {
      phone: {
        countryCode: countryCodes.INDIA,
        number: phoneNumber || "",
      },
      firstName: firstName || "",
      lastName: lastName || "",
      email: email || "",
      profession: showSelectedProfession,
      partnerType: LeadType.INDIVIDUAL,
      isExternalCommunicationAllowed:
        extraCommunication === false || undefined ? "No" : "Yes",
    };
    refetchPostAPIAfterOTP(
      `${URL.postFinalSigninUpFlow}`,
      successFulPostAPIObj
    );
  };

  React.useEffect(() => {
    if (!errorSuccessfullOTPEntryAPI && onSuccessfullOTPEntry) {
      setShowOTPfield(false);
      setUserVerified(true);
      triggerUserLogin(onSuccessfullOTPEntry.erpToken);
    } else {
      showErrorComponent(errorSuccessfullOTPEntryAPI);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onSuccessfullOTPEntry, errorSuccessfullOTPEntryAPI]);

  // Hook which is called whenever there is an error in any of the GET/POST API calls
  React.useEffect(() => {
    if (
      errorSuccessfullOTPEntryAPI ||
      errorSignUpAPI ||
      errorSuccessProfessionListAPI ||
      errorSuccessEnabledProfessionListAPI
    ) {
      setDisplayErrorComponent(true);
    }
  }, [
    errorSuccessfullOTPEntryAPI,
    errorSignUpAPI,
    errorSuccessProfessionListAPI,
    errorSuccessEnabledProfessionListAPI,
  ]);

  //Function which is triggered when there is an error in the OTPField Component
  const showErrorComponent = (isErrorpresent: ErrorObj) => {
    if (isErrorpresent && isErrorpresent?.message) {
      setDisplayErrorComponent(true);
      setShowRecievedErrorObjFromServer(isErrorpresent);
    }
  };

  // Function which enables/disabled the NEXT button
  const isSubmitAllowed = React.useMemo(() => {
    return !(
      firstName &&
      reCaptchaVerififed &&
      lastName &&
      phoneNumber &&
      reCaptchaVerififed &&
      phoneNumber.length > 9 &&
      showSelectedProfession
    );
  }, [
    firstName,
    phoneNumber,
    showSelectedProfession,
    lastName,
    reCaptchaVerififed,
  ]);

  // Function called on change of Recaptcha Component
  const onReCaptchaChange = (reCaptchaToken: string) => {
    console.log(reCaptchaToken);
    if (reCaptchaToken) {
      setReCaptchaVerififed(true);
    } else {
      setReCaptchaVerififed(false);
    }
  };

  const onCommunicationCheckBoxClick = (checked: boolean) => {
    setExtraCommunication(checked);
  };

  return (
    <span css={[responsiveStyles, signupStyle]}>
      <div className="container-fluid">
        <div
          className={`row responsive-dimensions ${
            isMobile || isTablet ? "" : "py-1"
          }`}
        >
          <div
            className={` ${
              isMobile || isTablet ? "col-md-5 col-sm-12 p-0" : "p-4 col-md-5"
            }`}
          >
            <img
              src={`${
                isMobile ? instructionsBckgndMobile : instructionsBckgnd
              }`}
              alt=""
              width={`${isMobile || isTablet ? "100%" : "300em"}`}
            />
          </div>

          <div
            className={`col-md-7 col-sm-12 relative-position ${
              isMobile || isTablet ? "py-4" : "pb-3 mt-2"
            }`}
          >
            {displayErrorComponent ? (
              <div className="d-flex align-items-center justify-content-center h-100">
                <SignUpError errorObj={showRecievedErrorObjFromServer} />
              </div>
            ) : loadingSignUpAPI ||
              loadingSuccessProfessionListAPI ||
              loadingSuccessEnabledProfessionListAPI ||
              loadingSuccessfullOTPEntryAPI ? (
              <div className="spinner-loading">
                <Spin size="large" />
              </div>
            ) : (
              <div>
                {!showOTPfield && !userVerified ? (
                  <div className="mt-3">
                    <div className="d-sm-none d-xs-block my-2">
                      <div className="m-2 heading-style text-center ">
                        Create Profile
                      </div>
                      <div className="text-center profile-message-style">
                        Already have a profile?{" "}
                        <button
                          className="border-0 bg-white edit-button-style user-button-style"
                          onClick={onGoBackClick}
                        >
                          LOGIN
                        </button>
                      </div>
                    </div>

                    <div className="">
                      <h6 className="mt-3">Select Profession</h6>
                      <RadioButtonSelect
                        value={professionsList}
                        defaultValue={showSelectedProfession}
                        onValueChange={onSelectedProfession}
                      />
                    </div>

                    {/* Disabled VERTICAL Message */}
                    {onSuccessEnabledProfessionList &&
                    showSelectedProfession ? (
                      !onSuccessEnabledProfessionList.includes(
                        showSelectedProfession
                      ) && (
                        <div className="mt-3 extra-info">
                          <DisplayInfo
                            status={Status.pending}
                            title={[
                              `Not actively looking to onboard ${showSelectedProfession}`,
                            ]}
                            description={[
                              "However you can submit your details with us and we will get back to you when we re-start the registration process",
                            ]}
                            widgetType={WidgetType.INFO}
                          />
                        </div>
                      )
                    ) : (
                      <React.Fragment />
                    )}
                    <div>
                      <div
                        className={` ${
                          isMobile
                            ? ""
                            : "d-flex  align-items-center justify-content-center"
                        }`}
                      >
                        <div className={`${isMobile ? "" : "pr-2"}`}>
                          <InputField
                            placeholder="First Name"
                            type="text"
                            className={`${
                              isMobile ? "" : "mobile-responsive-width"
                            }`}
                            initialValue={firstName}
                            onChange={onFirstNameChange}
                          />
                        </div>
                        <div className={`${isMobile ? "" : "pl-2"}`}>
                          <InputField
                            placeholder="Last Name"
                            className={`${
                              isMobile ? "" : "mobile-responsive-width"
                            }`}
                            type="text"
                            initialValue={lastName}
                            onChange={onLastNameChange}
                          />
                        </div>
                      </div>

                      <div className="">
                        <InputField
                          placeholder="Email Address"
                          type="text"
                          initialValue={email}
                          onChange={onEmailChange}
                          validationRegEx={regexValidation.email}
                          validationErrMsg={
                            "please enter a valid email address"
                          }
                        />
                      </div>

                      <div className="">
                        <Input.Group compact>
                          <Select defaultValue={phoneNumberPrefixes.india}>
                            <Option value={phoneNumberPrefixes.india}>
                              {phoneNumberPrefixes.india}
                            </Option>
                          </Select>
                          <InputField
                            placeholder="Phone Number"
                            type="number"
                            initialValue={phoneNumber}
                            onChange={onPhoneNumberChange}
                          />
                        </Input.Group>
                        <div className="opt-message text-left ">
                          OTP will be sent to this number for verification
                        </div>
                        <div className="my-2 extra-communication-box">
                          <img
                            src={whatsappIcon}
                            alt=""
                            className="whatsapp-img"
                          />
                          <Checkbox
                            label={`Allow Cult.fit to share update on your registration progress via Whatsapp.`}
                            onChange={onCommunicationCheckBoxClick}
                            checked={extraCommunication}
                          />
                        </div>
                      </div>
                      <div
                        className={`d-flex my-3 ${
                          isMobile || isTablet
                            ? "justify-content-center"
                            : "justify-content-start"
                        }`}
                      >
                        <ReCAPTCHA
                          ref={recaptchaRef}
                          sitekey={
                            window.location.hostname.includes("localhost")
                              ? process.env.REACT_APP_RECAPTCHA_LOCAL_SECRET //Hitesh account key
                              : process.env.REACT_APP_RECAPTCHA_SECRET //Org account key
                          }
                          onChange={onReCaptchaChange}
                          onErrored={reExecuteCaptchaVerification}
                          onExpired={reExecuteCaptchaVerification}
                          size={"invisible"}
                          badge={"bottomright"}
                        />
                      </div>
                    </div>

                    {isMobile || isTablet ? (
                      <div className="row  ">
                        <div className="col-1"></div>
                        <div className="col-10 p-0">
                          <button
                            className="button-style-red user-button-style w-100"
                            onClick={onJoinUsNowClick}
                            disabled={isSubmitAllowed}
                          >
                            <span className="responsive-text">
                              {joinUsNowText}
                            </span>
                          </button>
                        </div>
                        <div className="col-1"></div>
                        <div className="col-12 text-center mt-3">
                          <div className="d-flex align-items-center justify-content-center">
                            <div className="last-line-content mr-2">
                              Already Have a Profile?
                            </div>
                            <button
                              className="link-style border-0 user-button-style bg-white"
                              onClick={onLoginClick}
                            >
                              {login}
                            </button>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="d-flex desktop-footer-style">
                        <button
                          className="button-style-red user-button-style button-width mr-2"
                          onClick={onJoinUsNowClick}
                          disabled={isSubmitAllowed}
                        >
                          {joinUsNowText}
                        </button>
                        <div className="d-flex align-items-center">
                          <div className="last-line-content mx-2">
                            Already Have a Profile?
                          </div>
                          <button
                            className="link-style border-0 user-button-style bg-white login-button-style"
                            onClick={onLoginClick}
                          >
                            {login}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                ) : showOTPfield && !userVerified ? (
                  <div className="opt-field-container">
                    <OTPInputField
                      onGoBackClick={onGoBackClick}
                      onSignInClick={onSuccessFullOTPEnter}
                      phoneNumber={phoneNumber}
                      onResendOTP={onJoinUsNowClick}
                      hasErrorOccured={showErrorComponent}
                    />
                  </div>
                ) : !showOTPfield && userVerified ? (
                  <React.Fragment>
                    <div className="spinner-loading">
                      <Spin size="large" />
                    </div>
                  </React.Fragment>
                ) : (
                  <div className="spinner-loading">
                    <Spin size="large" />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </span>
  );
};
